import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Nav, Button } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import ProfileUnselect from '../../../../styles/images/profile-unselect-50.png';
import ProfileSelect from '../../../../styles/images/profile-selected-50.png';
import WalletUnselect from '../../../../styles/images/wallet-unselect-50.png';
import WalletSelect from '../../../../styles/images/wallet-selected-50.png';
import CloseIcon from '../../../../styles/images/close.png';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';

import { Sheet } from 'react-modal-sheet';


const FooterBase = (props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { token } = useSelector(state => state.user);
    const { isOpen } = useSelector(state => state.bottom_sheet);


    const handleToggleBottomSheetOpen = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', !isOpen));
        // if(!!token) {
        //     // if(profile.organization.status)
        //     if(profile.user_org_credit > 0)
        //         dispatch(handleChangeDataBottomSheet('isOpen', !isOpen));
        //     else
        //         navigate('../buy');
        // }
        // else
        //     navigate('../auth_err');
    };

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    const handleClickInstallments = () => {
        closeBottomSheet();
        if(!!token)
            navigate(`../installments`);
        else
            navigate(`../auth_err`);
    };

    const handleClickBuy = () => {
        closeBottomSheet();
        if(!!token)
            navigate(`../buy`);
        else
            navigate(`../auth_err`);
    };

    return (

        <Nav id="nav-bottom" className="navbar fixed-bottom text-center bg-white px-4" style={ !isOpen ? {boxShadow: '0px -5px 10px rgba(0, 0, 0, 0.2)'} : null }>

            {/* isOpen && (
                <div
                    onClick={() => closeBottomSheet()}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: -10,
                    }}
                />
            ) */}

            <Sheet style={{zIndex: "1"}} isOpen={isOpen} onClose={closeBottomSheet} detent="content-height" >
                <Sheet.Container style={{clipPath: 'ellipse(105% 80% at center 90%)', zIndex: '1000'}}>
                    <Sheet.Header className="p-2">
                        <img src={CloseIcon} onClick={closeBottomSheet} alt="close" />
                    </Sheet.Header>
                    <Sheet.Content>
                        <Row className="mt-3">
                            <Col xs={6} className="text-left" style={{marginBottom: '110px'}}>
                                <Button className="py-3 shopping-btn "  onClick={handleClickBuy} >
                                    <span className="font-size-16">نقدی</span>
                                </Button>
                            </Col>
                            <Col xs={6} className="text-right">
                                <Button className="py-3 shopping-btn "  onClick={handleClickInstallments}>
                                    اقساطی
                                </Button>
                            </Col>
                        </Row>
                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop  />
            </Sheet>

            


            <Row className="w-100 py-1 mx-0">
                <Col xs={4} className="text-center align-content-center">
                    <Link to="../wallet" className={"bottom-nav " + (props.selected !== undefined && props.selected === 'wallet' ? "bottom-nav-select" : "bottom-nav-unselect")} onClick={closeBottomSheet}>
                        <img src={props.selected !== undefined && props.selected === 'wallet' ? WalletSelect : WalletUnselect} height={30} alt="کیف پول" />
                        <br />
                        کیف پول
                    </Link>
                </Col>
                <Col xs={4} className="d-flex justify-content-center p-0" >
                    <div className="shopping-btn d-flex flex-column justify-content-center" onClick={handleToggleBottomSheetOpen} role="button" >
                        <span>پرداخت</span>
                    </div>
                </Col>
                <Col xs={4} className="text-center align-content-center">
                    <Link to="../profile" className={"bottom-nav " + (props.selected !== undefined && props.selected === 'profile' ? "bottom-nav-select" : "bottom-nav-unselect")} onClick={closeBottomSheet}>
                        <img src={props.selected !== undefined && props.selected === 'profile' ? ProfileSelect : ProfileUnselect} height={30} alt="پروفایل" />
                        <br />
                        پروفایل
                    </Link>
                </Col>
            </Row>

            

        </Nav>

    );
}

export default FooterBase;
